import React, { Component } from "react"
import { withTranslation } from 'react-i18next';
import { getNationalities, updateIdAndNationality, confirmIdAndNationalityUpdate, sendAuctionOtp } from '../../api/api';
import { GlobalContext } from "../../context/GlobalContext";
import { Select } from "mobily-ui-library/lib";
import Flag from 'react-world-flags';
import MapPin from "../../assets/MapPin.svg";
import $ from "jquery";

class IDNumAndNationality extends Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      idCheck: '',
      idNumber: '',
      nationality: null,
      nationalitiesList: [],
      profileMobileNumber: '',
      errors: {},
      hashcode: '',
      rtl: false
    }
  }

  componentDidMount = () => {
    const [context] = this.context;
    this.setState({
      profileMobileNumber: context.mobileNum,
      rtl: context.rtl
    })
    this.getNationalitiesData()
  }

  getNationalitiesData = async () => {
    const [context] = this.context;
    const { lang } = context
    const response = await getNationalities()
    const nationalities = JSON.parse(response?.data?.data?.nationalities)

    const nationalitiesList = nationalities.map((n) => {
      return lang === "ar" ? {
        id: n.value,
        icon: <Flag className="flagContainer" fallback={<img className="flagContainer" src={MapPin} alt={n.value} />} code={n.code} />,
        text: n.value_ar
      } :
        {
          id: n.value,
          icon: <Flag className="flagContainer" fallback={<img className="flagContainer" src={MapPin} alt={n.value} />} code={n.code} />,
          text: n.value_en
        }
    });

    this.setState({
      nationalitiesList: nationalitiesList
    })
  }

  lastDigitChecksumForId = (digits) => {
    var ln = digits.length;

    if (ln !== 9) {
      return -1;
    }

    var bits = digits;
    // take each odd digit, multiply by two, and then apply formula such that
    // 0 1 2 3 4 5 6 7 8 9 becomes:
    // --> 0 2 4 6 8 1 3 5 7 9
    // then add to running total
    var total = 0;
    for (var i = 0; i < 9; i += 2) {
      var v = parseInt(bits[i]);

      if (v < 5) {
        total = total + v * 2;
      } else {
        total = total + (2 * v - 9);
      }
    }
    // now add the even digits to this total
    for (var j = 1; j < 9; j += 2) {
      var w = parseInt(bits[j]);
      total = total + w;
    }
    // now take the ones digit of this total, called the MR digit...
    var MR = total % 10;

    // ...and return the last digit as:
    if (MR === 0) {
      return 0;
    } else {
      return 10 - MR;
    }
  };

  idCheckSum = (custId) => {
    var lastDigit = 0;
    var lastDigitChks = 0;
    lastDigit = parseInt(custId[9]);

    lastDigitChks = this.lastDigitChecksumForId(custId.substring(0, 9));

    if (lastDigit !== lastDigitChks) {
      return false;
    }
    return true;
  };

  handleIdNumChange = (event) => {
    const { rtl } = this.state
    let value = event.target.value.replace(/\s/g, '');

    const pattern = /^(((1)([0-9]){9})||((2)([0-9]){9}))$/
    const result = pattern.test(value);

    this.setState({ idNumber: value })

    if (this.idCheckSum(value)) {
      let errors = {}
      this.setState({
        idCheck: true,
        errors: errors,
      })
    } else {
      let errors = {}
      errors["idNumber"] = "not_a_valid_id";
      this.setState({
        idCheck: false,
        errors: errors,
      })
    }

    if (result && value.startsWith('1') && this.idCheckSum(value)) {
      this.setState({ nationality: rtl ? 'المملكة العربية السعودية' : 'Saudi Arabia' })
    } else {
      this.setState({ nationality: null })
    }
  }

  onFocus = (event) => {
    event.target.setAttribute("autocomplete", "off");
  };

  handleNationalitySelect = (value) => {
    this.setState({ nationality: value })
  };

  validateForm() {
    let errors = {};
    let formIsValid = true;
    const { idNumber, nationality, rtl } = this.state
    const pattern = /^(((1)([0-9]){9})||((2)([0-9]){9}))$/
    const result = pattern.test(idNumber);
    console.log("result", result)

    if (!idNumber) {
      formIsValid = false;
      errors["idNumber"] = "not_a_valid_id";
    }
    if (!nationality) {
      formIsValid = false;
      errors["nationality"] = "invalid_data";
    }
    if (!result) {
      formIsValid = false;
      errors["idNumber"] = "not_a_valid_id";
    }

    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  confirmIdAndNationality = async (e) => {
    const { hashcode } = this.state;
    const confirmIdAndNationalityResult = await confirmIdAndNationalityUpdate(hashcode);
    const { data } = confirmIdAndNationalityResult

    if (data.status.code === "MAPI-000") {
      $("#formLogin").attr("action", window.loginURL).submit();
    }
    else {
      let errors = {};
      errors["customError"] = "invalid_data";
      this.setState({
        errors: errors,
      });
    }
  }

  // getActiveVoiceLines = async (e) => {
  //   const { profileMobileNumber, idNumber } = this.state
  //   const [context, dispatch] = this.context;

  //   const activeVoiceLinesResult = await getActiveVoiceLines(idNumber);
  //   const activeAccounts = activeVoiceLinesResult?.data?.accounts

  //   if (activeAccounts?.length) {
  //     const cellularPhone = (activeVoiceLinesResult?.data?.contact[0]?.cellularPhone).replace(/\+/g, '');
  //     const isContactInfoSame = profileMobileNumber === cellularPhone
  //     const isMobileNumUnderSameId = activeAccounts.filter(account => {
  //       return account.idNumber === idNumber
  //     })

  //     dispatch({
  //       type: 'UPDATE_ACTIVE_VOICE_LINES',
  //       payload: { activeVoiceLines: activeAccounts }
  //     })

  //     if (isContactInfoSame && isMobileNumUnderSameId?.length) {
  //       // Case 1 -  If the active lines exist and profileMobileNumber in under the same ID
  //       // REMOVE
  //       this.confirmIdAndNationality()
  //     } else {
  //       // Case 2 - If the active lines exist and profileMobileNumber is NOT under same Id
  //       // REMOVE
  //       dispatch({
  //         type: 'GO_TO_SCREEN',
  //         payload: { profileUpdateScreen: "ActiveVoiceLines" }
  //       })
  //     }
  //   } else {
  //     // Case 3 - If the active lines doesn't exist / id not found
  //     // USE EXCLUSIVELY THIS CASE

  //     const orderId = new Date().getTime()
  //     const sendAuctionOtpResponse = await sendAuctionOtp(idNumber, "Absher", "", orderId);
  //     dispatch({
  //       type: 'UPDATE_ABSHER_OTP_TYPE',
  //       payload: {
  //         otpType: "Absher",
  //         orderId: orderId,
  //         serviceRequestID: sendAuctionOtpResponse?.data?.data?.serviceRequestID
  //       }
  //     })
  //     dispatch({
  //       type: 'GO_TO_SCREEN',
  //       payload: { profileUpdateScreen: "AbsherOtp" }
  //     })
  //   }
  // }

  handleProfileSubmit = async (e) => {
    console.log("handleProfileSubmit called")
    e.preventDefault();
    if (this.validateForm()) {
      const { idNumber, nationality } = this.state;
      const [context, dispatch] = this.context;

      const nationalityUpdateResult = await updateIdAndNationality(idNumber, nationality);
      console.log("nationalityUpdateResult", nationalityUpdateResult)
      const { data } = nationalityUpdateResult
      if (data.status.code === "MAPI-000") {
        this.setState({
          hashcode: data?.hashCode
        })
        dispatch({
          type: 'UPDATE_HASHCODE',
          payload: { hashCode: data?.hashCode }
        })
        
        //this.getActiveVoiceLines()

        // Directly navigating to Absher Otp in all cases now
        const orderId = new Date().getTime()
        const sendAuctionOtpResponse = await sendAuctionOtp(idNumber, "Absher", "", orderId);
        dispatch({
          type: 'UPDATE_ABSHER_OTP_TYPE',
          payload: {
            otpType: "Absher",
            orderId: orderId,
            serviceRequestID: sendAuctionOtpResponse?.data?.data?.serviceRequestID
          }
        })
        dispatch({
          type: 'GO_TO_SCREEN',
          payload: { profileUpdateScreen: "AbsherOtp" }
        })

      }
      else {
        let errors = {};
        errors["customError"] = "invalid_data";
        this.setState({
          errors: errors,
        });
      }
    }
  }

  render() {
    const { t } = this.props;
    const { idNumber, nationality, nationalitiesList, errors, idCheck } = this.state;
    const [context] = this.context;
    const { lang, rtl, dir } = context

    return (
      <div className="auction-profile-update">
        <div className="pu_subheading">{t("id_details_subheading")}</div>

        {errors.customError ? (
          <div className="alert alert-danger" role="alert">
            <b>
              {t(errors.customError)}{" "}
              <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
            </b>
          </div>
        ) : null}

        <div className={
          "profile-update " + "form-group " + (errors.idNumber ? "not-valid" : "")}>
          <input
            type="text"
            className="form-control pu-input-field"
            placeholder={t("id_number")}
            value={idNumber}
            onChange={this.handleIdNumChange}
            onFocus={this.onFocus}
            maxLength={10}
          />
          {this.state.errors.idNumber ? (
            <div className="alert alert-danger" role="alert">
              {t(this.state.errors.idNumber)}{" "}
              <i
                className="fa fa-exclamation-circle"
                aria-hidden="true"
              ></i>
            </div>
          ) : (
            <div className="empty-alert">&nbsp;</div>
          )}
        </div>

        <div className={
          "pu-dropdown-field " + (errors.nationality ? "not-valid" : "")}>
          <Select
            id="selectNationality"
            rtl={rtl}
            value={nationality}
            className="select_field"
            placeholder={t('nationality')}
            onChange={this.handleNationalitySelect}
            options={nationalitiesList}
            showSearch={true}
            disabled={idNumber === '' || idNumber.startsWith('1') || !idCheck ? true : false}
          />
        </div>
        {this.state.errors.nationality ? (
          <div className="alert alert-danger" role="alert" style={{ "marginTop": "0px" }}>
            {t(this.state.errors.nationality)}{" "}
            <i
              className="fa fa-exclamation-circle"
              aria-hidden="true"
            ></i>
          </div>
        ) : (
          <div className="empty-alert">&nbsp;</div>
        )}

        <div className="pu-button">
          <button id="idUpdateButton" onClick={this.handleProfileSubmit}
            type="submit"
            name="email_update_button"
            className="btn min_outlin_btn active">
            {t("update")}{" "}
            <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    )
  }
}

export default withTranslation()(IDNumAndNationality);
